export default [
  {
    name: 'add-component',
    icon: 'fa-plus',
    method: 'addComponent',
    classes: [],
    hoverable: false,
    menu: null,
  },
  {
    name: 'move',
    icon: 'fa-arrows-alt',
    method: null,
    classes: ['column-handle'],
    hoverable: false,
    menu: null,
  },
  {
    name: 'delete',
    icon: 'fa-trash-alt',
    method: 'removeParent',
    classes: [],
    hoverable: false,
    menu: null,
  },
  {
    name: 'settings',
    icon: 'fa-cog',
    method: 'openMenu',
    classes: [],
    hoverable: true,
    menu: 'column-menu',
  }
]